import React from 'react';
import { Button } from './Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
      errorId: null,
      copied: false
    };
  }

  static getDerivedStateFromError(error) {
    const errorId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

    return {
      hasError: true,
      error,
      errorId
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', {
      errorId: this.state.errorId,
      error,
      errorInfo
    });
  }

  handleCopyError = async () => {
    const { error, errorId } = this.state;

    const errorText = [
      `Error ID: ${errorId}`,
      `Message: ${error?.message || 'Unknown error'}`,
      `Name: ${error?.name || 'Unknown error'}`,
      `Stack: ${error?.stack || 'No stack'}`
    ].join('\n');

    try {
      await navigator.clipboard.writeText(errorText);

      this.setState({
        copied: true
      });

      setTimeout(() => {
        this.setState({
          copied: false
        });
      }, 2000);
    } catch (e) {
      console.error('Failed to copy error:', e);
    }
  };

  render() {
    if (this.state.hasError) {
      const { error, errorId, copied } = this.state;

      return (
        <div className="flex flex-col items-center justify-center min-h-screen [background:linear-gradient(180deg,rgb(1,13,13)_0%,rgb(3.01,42.5,42.5)_100%)] bg-[100%_100%] bg-repeat-y bg-cover text-white p-4">
          <img
            src="/images/error-page.png"
            alt="error-page"
            className="w-full max-w-[343px] h-full max-h-[343px] mb-[21px]"
          />

          <h2 className="text-2xl font-bold mb-2.5">
            Внутренняя ошибка сервера
          </h2>

          <p className="text-gray-400 mb-[24px] text-center">
            Пожалуйста, попробуйте повторить ваш запрос позже. Мы работаем над
            устранением проблемы. Спасибо за понимание.
          </p>

          {/* Техническая информация */}
          <div className="w-full max-w-[343px] mb-6">
            <div className="flex items-center justify-between gap-2 bg-white/10 rounded-lg px-3 py-2">
              <div className="min-w-0">
                <p className="text-xs text-gray-400">
                  Код ошибки
                </p>

                <p className="text-sm font-mono truncate">
                  {errorId}
                </p>
              </div>

              <button
                type="button"
                onClick={this.handleCopyError}
                className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-white/10 active:bg-white/20"
                aria-label="Скопировать информацию об ошибке"
              >
                {copied ? (
                  <span className="text-[#A1F69E] text-sm">
                    ✓
                  </span>
                ) : (
                  <img
                    src="/icons/copy.svg"
                    alt="Копировать"
                    className="w-5 h-5"
                  />
                )}
              </button>
            </div>

            {/* Короткое описание ошибки */}
            {error?.message && (
              <p className="mt-2 px-1 text-xs text-gray-500 truncate">
                {error.message}
              </p>
            )}
          </div>

          <Button
            className="w-full max-w-[343px]"
            onClick={() => window.location.reload()}
          >
            Вернуться на главную
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;